import Skeleton from '@carvana/ds-skeleton';

export default function TradeLoadingCard() {
  return (
    <div
      aria-busy="true"
      aria-label="Loading trade offer"
      aria-live="polite"
      className="min-h-[202px] rounded-md border border-border-weak bg-background-default p-2xl"
      data-testid="trade-loading-card"
      role="status"
    >
      <div className="flex h-full flex-col justify-between gap-xl">
        {/* Header: Title and Badge */}
        <div className="flex justify-between">
          <Skeleton height={26} width={110} />
          <Skeleton height={26} width={120} />
        </div>

        <div className="flex gap-lg">
          {/* Car image thumbnail */}
          <Skeleton height={70} width={80} className="shrink-0" />

          {/* Vehicle details */}
          <div className="flex w-full flex-col gap-md">
            <Skeleton height={18} width="90%" />
            <div className="flex gap-md">
              <Skeleton height={18} width={80} />
              <Skeleton height={18} width={80} />
            </div>
            <Skeleton height={18} width={123} />
          </div>
        </div>

        {/* Button */}
        <Skeleton height={40} width="100%" className="rounded-full" />
      </div>
    </div>
  );
}
